import { Errors } from "../client";
import flatpickr from "flatpickr";
import { Hebrew } from "flatpickr/dist/l10n/he.js";
flatpickr.localize(Hebrew);

export default {
    data() {
        return {
            flatpickr: flatpickr,
        };
    },
    props: {
        form: {
            type: Object,
            default: () => ({}),
        },
        step: {
            type: Object,
            default: () => ({}),
        },
        currentStep: {
            type: Number,
            default: 0,
        },
        errors: {
            type: Errors,
        },
    },
    computed: {
        stepForm() {
            console.log(
                "this.form[this.$options.name]",
                this.form[this.$options.name]
            );

            return this.form[this.$options.name];
        },
        constants() {
            return this.step.constants;
        },
    },
};
